import { TitleHeader } from "./TitleHeader";
import { TwoColumn } from "./TwoColumn";

interface IProps {
  title: string;
  header: string;
  element: JSX.Element;
  isReversed?: boolean;
  className?: string;
}

export const HalfRow = ({
  title,
  header,
  element,
  isReversed,
  className,
}: IProps) => {
  const titleHalf = (
    <div className={"flex flex-col text-center px-4 md:pr-12"}>
      <TitleHeader title={title} header={header} />
    </div>
  );

  const contentHalf = (
    <div className={"flex flex-row p-8 md:pl-12 items-center"}>{element}</div>
  );

  return (
    <TwoColumn
      left={titleHalf}
      right={contentHalf}
      isReversed={isReversed}
      className={`px-2 py-8 md:p-24 max-h-[64rem] ${className}`}
      hasDivider={true}
    />
  );
};
